import React, { useContext, useState } from 'react';
import { useHistory,useLocation } from 'react-router-dom';
import { sortBy, orderBy } from 'lodash-es';
import styled from 'styled-components';
import { KeyParamsTable } from '@ikea-food-ux/ppsi';
import DataContext from '../components/DataContext/DataContext';
import useRoutes from '../routes/useRoutes';

const ContainerStyle = styled.div`
  margin: 1rem 0.5rem;
`;

const PrepAndProdCheatSheetView = () => {
  const history = useHistory();
  const routes = useRoutes();
  const {
    ppis,
    labels,
    timeUnits,
    temperatureUnits,
    firstStorage,
    productionOptions,
    language,
    shelfLifeTimeUnits
  } = useContext(DataContext);
  const location = useLocation();
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [updatedPpis, setUpdatedPpis] = useState([]);

  const navigateToPpi = id => {
    history.push(routes.ppiRoute(id));
  };

  var sortedPpisAlphabetic = sortBy(
    ppis,
    ppi => ppi.info[language] && ppi.info[language].presentationName
  );

  var storageIdArray = [];
  sortedPpisAlphabetic.forEach(item => {
    storageIdArray.push(item.firstStorage);
  });
  const uniqueStorageId = [...new Set(storageIdArray)];
  // console.log("location",location,firstStorage)
  let storageFilterList = [];
  uniqueStorageId.forEach(id => {
    let obj = {};
    obj.key = id;
    if (firstStorage.length > 0) {
      let stockName = firstStorage.filter(item => item.code === id);
      obj.value = stockName.length > 0 ? stockName[0].info[language].name : id;
    }
    storageFilterList.push(obj);
  });
  let sortedStorageFilterList = storageFilterList.length > 0 ? sortBy(storageFilterList, item => item.value) : [] 
  // console.log(sortedStorageFilterList)
  const filteredPpis = filterCategory => {
    var sortedPpis = sortBy(
      ppis,
      ppi => ppi.info[language] && ppi.info[language].presentationName
    );
    // console.log("sortedppis",sortedPpis)
    let updatedPpis = sortedPpis;
    if (filterCategory.length > 0) {
      filterCategory.forEach(item => {
        if (item.filterValue.length > 0) {
          updatedPpis = sortedPpis.filter(ele => {
            return item.filterValue.includes(ele[item.filterName]);
          });
        }
      });

      updatedPpis = sortBy(
        updatedPpis,
        ppi => ppi.info[language] && ppi.info[language].presentationName
      );
      // console.log("location",location)
      if (location.data && location.data['menuSelected']) {
        var dateBasedArray = [];
        var alphabeticalBasedArray = [];
        if (
          location.data['menuSelected'].key === 'new' ||
          location.data['menuSelected'].key === 'updated'
        ) {
          updatedPpis.forEach(item => {
            if (location.data['menuSelected'].key === 'new') {
              if (item.ppiTag === 'new') {
                dateBasedArray.push(item);
              } else {
                alphabeticalBasedArray.push(item);
              }
            } else if (location.data['menuSelected'].key === 'updated') {
              if (item.ppiTag === 'updated') {
                dateBasedArray.push(item);
              } else {
                alphabeticalBasedArray.push(item);
              }
            }
          });
    
          let result1 = orderBy(
            dateBasedArray,
            ppsis => ppsis.actualPublishDate,
            'desc'
          );
          let result2 = sortBy(
            alphabeticalBasedArray,
            ppsis => ppsis.info[language] && ppsis.info[language].presentationName
          );
          updatedPpis = [...result1, ...result2];
        }
      }


      // console.log('updatedPpis', updatedPpis);
    }
    setUpdatedPpis(updatedPpis);
  };

  const filterByStorageId = (columnName, selectedObj) => {
    // console.log('52', columnName, selectedObj);
    var tmpselectedFilters = JSON.parse(JSON.stringify(selectedFilters));
    if (tmpselectedFilters.length === 0) {
      let obj = {};
      obj.filterName = columnName;
      obj.filterValue = [];
      obj.filterValue.push(selectedObj.key);
      tmpselectedFilters.push(obj);
    } else {
      let filteredList = [];
      tmpselectedFilters.forEach((ele, index) => {
        if (ele.filterName === columnName) {
          filteredList.push(ele);
          tmpselectedFilters.splice(index, 1);
        }
      });
      if (filteredList.length > 0) {
        // console.log(filteredList[0]['filterValue']);
        if (filteredList[0]['filterValue'].indexOf(selectedObj.key) > -1) {
          //    console.log(filteredList[0]['filterValue'].splice(filteredList[0]['filterValue'].indexOf(selectedObj.key),1))
          filteredList[0]['filterValue'].splice(
            filteredList[0]['filterValue'].indexOf(selectedObj.key),
            1
          );
        } else {
          filteredList[0]['filterValue'].push(selectedObj.key);
        }
      }
      tmpselectedFilters.push(filteredList[0]);
    }
    setSelectedFilters(tmpselectedFilters);
    filteredPpis(tmpselectedFilters);

  };

  const sortPpisforCategoryAndStorage=(listToSort)=>{
   let tmpsortedPpis = sortBy(
    listToSort,
      ppi => ppi.info[language] && ppi.info[language].presentationName
    );
    // console.log("location",location)
    if (location.data && location.data['menuSelected']) {
      let dateBasedArray = [];
      let alphabeticalBasedArray = [];
      if (
        location.data['menuSelected'].key === 'new' ||
        location.data['menuSelected'].key === 'updated'
      ) {
        tmpsortedPpis.forEach(item => {
          if (location.data['menuSelected'].key === 'new') {
            if (item.ppiTag === 'new') {
              dateBasedArray.push(item);
            } else {
              alphabeticalBasedArray.push(item);
            }
          } else if (location.data['menuSelected'].key === 'updated') {
            if (item.ppiTag === 'updated') {
              dateBasedArray.push(item);
            } else {
              alphabeticalBasedArray.push(item);
            }
          }
        });
  
        let result1 = orderBy(
          dateBasedArray,
          ppsis => ppsis.actualPublishDate,
          'desc'
        );
        let result2 = sortBy(
          alphabeticalBasedArray,
          ppsis => ppsis.info[language] && ppsis.info[language].presentationName
        );
        // console.log(result1, result2);
  
        tmpsortedPpis = [...result1, ...result2];
      }
    }
    return tmpsortedPpis;
  }

  let listToSort = updatedPpis.length > 0 ? updatedPpis : ppis;
  let sortedPpis = sortPpisforCategoryAndStorage(listToSort)
  // var sortedPpis = updatedPpis.length > 0 ? updatedPpis : sortedPpis

  sortedPpis = sortedPpis.map(itm=>({
    ...itm,
    isNew: itm.ppiTag==='new',
    isUpdated: itm.ppiTag === 'updated'
  }))
let sortedNew=sortedPpis.filter(itm=>itm.ppiTag === 'new')
let sortedUpdated = sortedPpis.filter(itm=>itm.ppiTag === 'updated')
let newUpArray = [...sortedNew, ...sortedUpdated]
let combArry = orderBy(
  newUpArray,
  ppis => ppis.latestKCUpdate,
  'desc'
)
// let finalArray = [...combArry, ...sortedPpis.filter(itm=>!itm.ppiTag)]
let finalArray = [...newUpArray, ...sortedPpis.filter(itm=>!itm.ppiTag)]
  return (
    <ContainerStyle>
      <KeyParamsTable
        ppis={finalArray}
        language={language}
        labels={labels}
        timeUnits={timeUnits}
        temperatureUnits={temperatureUnits}
        stockHierarchy={firstStorage}
        productionOptions={productionOptions}
        onClick={navigateToPpi}
        storageFilterList={sortedStorageFilterList}
        onClickFilter={filterByStorageId}
        selectedFilters={selectedFilters}
        shelfLifeTimeUnits={shelfLifeTimeUnits}
      />
    </ContainerStyle>
  );
};

export default PrepAndProdCheatSheetView;
